import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})
export class OrdersService {

  constructor(private http: HttpClient) {}

  getOrders(){
    return this.http.get(environment.apiUrl + 'orders');
  }
  delete(id: number) {
    return this.http.delete(environment.apiUrl +  `admin/order/destroy/${id}`);
  }
}
